/*eslint-disable*/

import React from "react";

 
import { Navbar, Container } from 'react-bootstrap';

function Heading() {
   

 
  return (
  
<>
        <h4 className='text-center' >
        <a href='/marvel-dent' id="main-heading" >
         comic book collector 
        </a>
        </h4>
        
</>
       
  );
}

export default Heading;